

import { PanelMixins } from "./components/mixins";
import Vue from 'vue';
import { Unit } from "orbatchart";


import testOrbat from "./testorbat.json";

const ORBAT1: Unit = testOrbat;

export default Vue.extend({
  mixins: [PanelMixins],
  components: {},
  data: () => ({
    drawer: null,
  }),
  created() {
    this.$store.commit("setOrbat", [ORBAT1]);
  },
});
